import React, { useState, useEffect } from 'react'
import { ChevronDown } from 'lucide-react'
import { motion, AnimatePresence } from 'framer-motion'

// Define the list of admin emails
const adminEmails = [
  'oyierallan@yahoo.com',
  'allan.oyier@farmnet.africa',
  'farmnetafr@gmai.com',
  'oyiergweth@gmail.com'
]

const Header = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [adminEmail, setAdminEmail] = useState('')

  useEffect(() => {
    // Get the admin email from localStorage or session
    const email = localStorage.getItem('adminEmail') || 'Super Admin'
    setAdminEmail(email)
  }, [])

  return (
    <div className='w-full border-b-[3px] md:px-10 border-[#EDF0EF] bg-[#FAFBFB] p-4 md:h-[84px] h-[60px] flex items-center justify-between'>
      {/* Left: Logo */}
      <div className='w-[200px] h-[43px]'>
        <img
          src='https://res.cloudinary.com/dzngpgki4/image/upload/v1749659753/image_1745_kzcauj.png'
          alt='Logo'
          className='w-full h-full object-contain'
        />
      </div>

      {/* Right: Dropdown */}
      <div className='relative'>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className='flex flex-col items-end text-left'
        >
          <div>
            <div className='flex items-center gap-2 text-[20px] font-bold text-gray-800'>
              {adminEmail}
              <ChevronDown className='w-8 h-8' />
            </div>
            <span className='text-[16px] font-normal text-gray-600'>
              Super Admin
            </span>
          </div>
        </button>

        {/* Dropdown Menu */}
        <AnimatePresence>
          {isOpen && (
            <motion.ul
              initial='hidden'
              animate='visible'
              exit='hidden'
              variants={{
                hidden: { opacity: 0, y: -10 },
                visible: {
                  opacity: 1,
                  y: 0,
                  transition: {
                    staggerChildren: 0.1,
                  },
                },
              }}
              className='absolute right-0 mt-2 w-52 bg-white shadow-lg rounded-lg overflow-hidden z-50 border border-gray-200'
            >
              {adminEmails.map((email, index) => (
                <motion.li
                  key={index}
                  variants={{
                    hidden: { opacity: 0, y: -10 },
                    visible: { opacity: 1, y: 0 },
                  }}
                  className={`px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-700 ${
                    email === adminEmail ? 'bg-blue-50 font-semibold' : ''
                  }`}
                  onClick={() => {
                    setAdminEmail(email)
                    localStorage.setItem('adminEmail', email)
                    setIsOpen(false)
                  }}
                >
                  {email}
                </motion.li>
              ))}
            </motion.ul>
          )}
        </AnimatePresence>
      </div>
    </div>
  )
}

export default Header